import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sid = params.get("session_id");
  const [msg, setMsg] = useState("Confirming your payment…");
  const [merchDone, setMerchDone] = useState(false);
  const [squareDone, setSquareDone] = useState(false);
  const tries = useRef(0);

  useEffect(() => {
    if (!sid) { setMsg("Missing payment session."); return; }
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid" && data.order_id) {
          if (data.kind === "merch") { setMerchDone(true); return; }
          if (data.kind === "squares") { setSquareDone(true); return; }
          navigate(`/tickets/${data.order_id}`); return;
        }
        if (data.status === "expired" || data.payment_status === "failed") { setMsg("Payment failed or expired. Please try again."); return; }
      } catch (e) { tries.current += 1; }
      tries.current += 1;
      if (tries.current > 25) { setMsg("Still processing — check your email for confirmation."); return; }
      if (!stop) setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sid, navigate]);

  if (squareDone) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-5 text-center" data-testid="payment-success">
        <CheckCircle2 className="text-[#f3c649]" size={56} />
        <h1 className="headline text-3xl text-[#f7f3ec]">Your Square Is Locked In!</h1>
        <p className="text-[#a9a196] max-w-md">Thanks for supporting the cause. We've emailed your confirmation — good luck on game day! 🏈</p>
        <Link to="/squares" className="btn-gold rounded-full px-6 py-3 font-display uppercase tracking-wide mt-2">Back to the Board</Link>
      </div>
    );
  }

  if (merchDone) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-5 text-center" data-testid="payment-success">
        <CheckCircle2 className="text-[#f3c649]" size={56} />
        <h1 className="headline text-3xl text-[#f7f3ec]">Order Confirmed!</h1>
        <p className="text-[#a9a196] max-w-md">Thanks for repping the movement. We've emailed your receipt and we'll be in touch about your order.</p>
        <Link to="/shop" className="btn-gold rounded-full px-6 py-3 font-display uppercase tracking-wide mt-2">Back to Shop</Link>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-5 text-center" data-testid="payment-success">
      <Loader2 className="animate-spin text-[#e0481f]" size={44} />
      <p className="text-[#d6cec2] text-lg">{msg}</p>
      <Link to="/events" className="text-[#f3c649]">Back to events</Link>
    </div>
  );
}
